/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Build_ResultsInputs */

const en_us2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`No exercises`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises`)
	
};

const pt_br2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nenhum exercício`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const es_419_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Ningún ejercicio`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios`)
	
};

const pt_pt2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nenhum exercício`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const fr_fr2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Aucun exercice`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices`)
	
};

const de_de2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Keine Übungen`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen`)
	
};

const it_it2_plan_build_results = /** @type {(inputs: Plan_Build_ResultsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nessun esercizio`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "0" | "No exercises" |
* | "1" | "1 exercise" |
* | * | "{count} exercises" |
*
* @param {Plan_Build_ResultsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_results = /** @type {((inputs: Plan_Build_ResultsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_ResultsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_results(inputs)
	if (locale === "es-419") return es_419_plan_build_results(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_results(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_results(inputs)
	if (locale === "de-DE") return de_de2_plan_build_results(inputs)
	if (locale === "it-IT") return it_it2_plan_build_results(inputs)
	return en_us2_plan_build_results(inputs)
});
export { plan_build_results as "plan-build.results" }